<template>
    <v-card>
        <v-btn
            icon
            @click="cancelBtn"
            style="margin-left: 96%;position: absolute"
        >
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text style="padding: 0 22px 0px">
            <v-row class="pa-6" align="center" justify="center">
                <v-col cols="12" md="2">
                    <p class="display-1 text--primary text-center">
                        {{ studentDetail.name }}
                    </p>
                    <div class="display-1 text-center text-h5" style="color: red">
                        {{ studentDetail.studentType == 2 ? "重修" : studentDetail.studentType == 3 ? "预科" : "" }}
                    </div>
                </v-col>
                <v-col cols="12" md="10" class="pl-12 body-2 font-weight-black">
                    <v-row align="center" justify="center">
                        <v-col cols="12" md="3" >
                            年龄：{{ studentDetail.age }}
                        </v-col>
                        <v-col cols="12" md="3">
                            性别：{{ studentDetail.gender }}
                        </v-col>
                        <v-col cols="12" md="3">
                            注册班级：{{ studentDetail.firstClassName }}

                        </v-col>
                        <v-col cols="12" md="3">
                            班级：{{ studentDetail.className }}

                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-col cols="12" md="6">
                            手机号：{{ studentDetail.mobile }}

                        </v-col>
                        <v-col cols="12" md="6">

                            紧急联系人：{{ studentDetail.emergencyPerson }}
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-col cols="12" md="6">
                            学校：{{ studentDetail.schoolName }}
                        </v-col>
                        <v-col cols="12" md="6">
                            紧急联系人电话：{{ studentDetail.emergencyCall }}
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-col cols="12" md="6">
                            籍贯：{{ studentDetail.nativePlace }}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-divider></v-divider>
        <v-container>
            <v-row>
                <v-col cols="2" class="ml-10">
                    <v-switch
                        v-model="switch1"
                        label="面试"
                        @change="initEcharts"
                    ></v-switch>
                </v-col>
                <v-col cols="2">
                    <v-switch
                        v-model="switch2"
                        label="笔试"
                        @change="initEcharts"
                    ></v-switch>
                </v-col>
            </v-row>
        </v-container>
        <et-charts :option="options" ref="etchartsRef" style="height: 450px"></et-charts>

        <v-row no-gutters style="margin-top: 3%;">
            <v-col>
                <!-- 第一行 -->
                <v-row no-gutters>
                    <v-col cols="11" class="ml-12" md="11">
                        <v-card>
                            <h1 class="title">老师评价</h1>
                            <v-data-table color="grey darken-3"
                                          :items-per-page="5"
                                          :headers="teacherHeaders"
                                          :items="teacherDesserts"
                                          single-select
                                          class="elevation-1"
                                          :loading="teacherLoading"
                                          :footer-props="teaFooterProps"
                                          :loading-text="loadingText"
                                          :options.sync="teacherOptions"
                                          :server-items-length="teacherTotalDesserts"
                                          @update:options="teaChangeOptions"
                            >
                                <template v-slot:item.username="{ item }">
                                    <div v-if="ifShowUserName">
                                        {{ item.username }}
                                    </div>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="watchPic(item)" v-if="item.fileIds.length > 0">
                                        mdi-picture-in-picture-top-right
                                    </v-icon>
                                    <v-icon class="ml-2" @click="ShowUserName">
                                        {{ userNameIcon }}
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="11" class="ml-12 mt-12" md="11">
                        <v-card>
                            <h1 class="title">跟踪记录</h1>
                            <v-data-table color="grey darken-3"
                                          :items-per-page="5"
                                          :headers="recordHeaders"
                                          :items="recordDesserts"
                                          single-select
                                          class="elevation-1"
                                          :loading="recordLoading"
                                          :footer-props="recordFooterProps"
                                          :loading-text="loadingText"
                                          :options.sync="recordOptions"
                                          :server-items-length="recordTotalDesserts"
                                          @update:options="recordChangeOptions"
                            >
                                <template v-slot:item.username="{ item }">
                                    <div v-if="ifShowUserName2">
                                        {{ item.username }}
                                    </div>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="watchPic(item)" v-if="item.fileIds.length > 0">
                                        mdi-picture-in-picture-top-right
                                    </v-icon>
                                    <v-icon class="ml-2" @click="ShowUserName2">
                                        {{ userNameIcon2 }}
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="11" class="ml-12 mt-12" md="11">
                        <v-card>
                            <h1 class="title">外包评论</h1>
                            <v-data-table color="grey darken-3"
                                          :items-per-page="5"
                                          :headers="recordHeaders"
                                          :items="outApprise"
                                          single-select
                                          class="elevation-1"
                                          :loading="outAppriseLoading"
                                          :footer-props="recordFooterProps"
                                          :loading-text="loadingText"
                                          :options.sync="outAppriseOptions"
                                          :server-items-length="outAppriseTotalDesserts"
                                          @update:options="outAppriseChangeOptions"
                            >
                                <template v-slot:item.username="{ item }">
                                    <div v-if="ifShowUserName2">
                                        {{ item.username }}
                                    </div>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="watchPic(item)" v-if="item.fileIds.length > 0">
                                        mdi-picture-in-picture-top-right
                                    </v-icon>
                                    <v-icon class="ml-2" @click="ShowUserName2">
                                        {{ userNameIcon2 }}
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters style="margin-top: 4%">
            <v-col>
                <!-- 第一行 -->
                <v-row no-gutters>
                    <v-col class="ml-12" cols="11" md="11">
                        <v-card>
                            <h1 class="title">转班记录</h1>
                            <v-data-table color="grey darken-3"
                                          :items-per-page="5"
                                          :headers="transferHeaders"
                                          :items="transferDesserts"
                                          single-select
                                          class="elevation-1"
                                          :loading="transferLoading"
                                          :footer-props="transferFooterProps"
                                          :loading-text="loadingText"
                                          :options.sync="transferOptions"
                                          :server-items-length="transferTotalDesserts"
                                          @update:options="transferChangeOptions"
                            >

                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col class="ml-12 mt-12" cols="11" md="11">
                        <v-card>
                            <h1 class="title">异常考勤</h1>
                            <v-data-table color="grey darken-3"
                                          :items-per-page="5"
                                          :headers="studentHeaders"
                                          :items="studentDesserts"
                                          single-select
                                          class="elevation-1"
                                          :loading="studentLoading"
                                          :footer-props="footerProps"
                                          :loading-text="loadingText"
                                          :options.sync="studentOptions"
                                          :server-items-length="studentTotalDesserts"
                                          @update:options="changeOptions"
                            >
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-card-actions>
        </v-card-actions>
        <img ref="imgRef" v-show="false" :src="filePath" preview="1" :preview-text="fileDesc">
    </v-card>
</template>
<script>
import echarts from 'echarts'

export default {
    props: {
        showDetail: Boolean,
        stuDetailMsg: Object
    },
    model: {
        prop: 'showDetail',
        event: 'changeShowDetail'
    },
    data() {
        return {
            ifShowUserName: false,
            ifShowUserName2: false,
            fileDesc: '',
            filePath: '',
            fileId: '',
            studentDetail: {},
            initFlag: false,
            searchData: {
                stuId: this.stuDetailMsg.studentId,
                examType: [],
            },
            switch1: true,
            switch2: true,
            options: {
                backgroundColor: "#ffffff",
                legend: {
                    name: ['环比'],
                    right: 20,
                    top: 20
                },
                tooltip: {
                    trigger: 'axis',
                },
                xAxis: [{
                    type: 'category',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#6c50f3"
                        }
                    },
                    splitArea: {
                        color: '#f00',
                        lineStyle: {
                            color: '#f00'
                        },
                    },
                    axisLabel: {
                        interval:0,
                        rotate:10,
                        lineStyle: {
                            color: "#6c50f3"
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    boundaryGap: false,
                    data: [],

                }],

                yAxis: [{
                    name: "单位（分数）",
                    nameTextStyle: {
                        color: "#6c50f3",
                        fontSize: 14,
                        padding: [0, 0, 20, 0]//上右下左
                    },
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(255,255,255,0.1)'
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#6c50f3"
                        }
                    },
                    axisLabel: {
                        show: true,
                        margin: 20,
                        textStyle: {
                            color: '#6c50f3',

                        },
                    },
                    axisTick: {
                        show: true,
                        lineStyle: {
                            color: "#6c50f3"
                        }
                    },
                }],
                series: [{
                    name: '周比',
                    type: 'line',
                    smooth: true,
                    showAllSymbol: true,
                    symbol: 'circle',
                    symbolSize: 25,
                    markLine: {
                        itemStyle: {
                            normal: { lineStyle: { type: 'solid', color: '#6c50f3' }},
                        },
                        data: [
                            {type: 'average', name: '平均值'}
                        ],
                    },
                    lineStyle: {
                        normal: {
                            color: "#6c50f3",
                            shadowColor: 'rgba(0, 0, 0, .3)',
                            shadowBlur: 0,
                            shadowOffsetY: 5,
                            shadowOffsetX: 5,
                        },
                    },
                    label: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: '#6c50f3',
                        }
                    },
                    itemStyle: {
                        color: "#6c50f3",
                        borderColor: "#fff",
                        borderWidth: 3,
                        shadowColor: 'rgba(0, 0, 0, .3)',
                        shadowBlur: 0,
                        shadowOffsetY: 2,
                        shadowOffsetX: 2,
                    },
                    tooltip: {
                        show: false
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(108,80,243,0.3)'
                            },
                                {
                                    offset: 1,
                                    color: 'rgba(108,80,243,0)'
                                }
                            ], false),
                            shadowColor: 'rgba(108,80,243, 0.9)',
                            shadowBlur: 20
                        }
                    },
                    data: []
                }]
            },
            studentTotalDesserts: 0,
            studentDesserts: [],
            loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
            footerProps: {
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageOptions:[5,10,20,50],
                //disableItemsPerPage:true,
            },
            studentLoading: false,
            studentOptions: {},
            studentHeaders: [
                {
                    text: '班级',
                    value: 'className'
                },
                {
                    text: '描述',
                    value: 'attendanceResultDesc',
                },
                {
                    text: '时间',
                    value: 'attendanceTime'
                }
            ],
            teacherTotalDesserts: 0,
            teacherDesserts: [],
            teaFooterProps: {
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageOptions:[5,10,20,50],
                //disableItemsPerPage:true,
            },
            teacherLoading: false,
            teacherOptions: {},
            teacherHeaders: [
                {
                    text: '描述',
                    value: 'comment',
                    width: '700px',
                },
                {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
            ],
            recordTotalDesserts: 0,
            recordDesserts: [],
            outApprise:[],
            outAppriseLoading:false,
            outAppriseTotalDesserts:0,
            outAppriseOptions:{},
            recordFooterProps: {
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageOptions:[5,10,20,50],
                //disableItemsPerPage:true,
            },
            recordLoading: false,
            recordOptions: {},
            recordHeaders: [
                {
                    text: '描述',
                    value: 'comment',
                    width: '700px'
                },
                {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
            ],
            transferTotalDesserts: 0,
            transferDesserts: [],
            transferFooterProps: {
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageOptions:[5,10,20,50],
                //disableItemsPerPage:true,
            },
            transferLoading: false,
            transferOptions: {},
            transferHeaders: [
                {
                    text: '转入班级',
                    value: 'classInName'
                },
                {
                    text: '转出班级',
                    value: 'classOutName'
                },
                {
                    text: '转班日期',
                    value: 'transferDate'
                }
            ],
        }
    },
    mounted() {
        this.updateStudentMsg()
        this.initEcharts()
        this.initAllTab()
    },
    watch: {
        fileId() {
            if (this.fileId) {
                let _this = this
                this.filePath = this.$file.fileDownload(this.fileId)
                setTimeout(function () {
                    _this.$refs.imgRef.click()
                }, 100)
            }
        },
        showDetail() {
            this.initFlag = true
            this.switch1 = true
            this.switch2 = true
            this.initEcharts()
            this.updateStudentMsg()
            if (this.showDetail) {
                this.initAllTab()
            }
        },
    },
    computed: {
        userNameIcon: function () {
            if (this.ifShowUserName)
                return "mdi-eye"
            else
                return "mdi-eye-off"
        },
        userNameIcon2: function () {
            if (this.ifShowUserName2)
                return "mdi-eye"
            else
                return "mdi-eye-off"
        },
        dessertsClass(num) {
            return function (num) {
                let returnClass = "message-serial "
                switch (num) {
                    case 1:
                        return returnClass + "message-cl-one"
                    case 2:
                        return returnClass + "message-cl-two"
                    case 3:
                        return returnClass + "message-cl-three"
                    case 4:
                        return returnClass + "message-cl-four"
                    case 5:
                        return returnClass + "message-cl-five"
                }
                return returnClass
            }
        },
    },
    methods: {
        ShowUserName() {
            this.ifShowUserName = !this.ifShowUserName
            if (!this.ifShowUserName) {
                this.teacherHeaders.splice(0, 1)
            } else {
                this.teacherHeaders.splice(0, 0, {
                    text: '用户',
                    value: 'username',
                })
            }
        },
        ShowUserName2() {
            this.ifShowUserName2 = !this.ifShowUserName2
            if (!this.ifShowUserName2) {
                this.recordHeaders.splice(0, 1)
            } else {
                this.recordHeaders.splice(0, 0, {
                    text: '用户',
                    value: 'username',
                })
            }
        },
        watchPic(item) {
            this.fileId = ''
            this.fileDesc = ''
            this.$api.studentRecords.lookPic(item.id).then(data => {
                if (data.data && data.data.length > 0) {
                    this.fileId = data.data[0].fileId
                    this.fileDesc = item.comment
                } else {
                    this.$dialog.alert("暂无图片展示")
                }

            })
        },
        initStudentTransfer() {
            this.transferLoading = true
            this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
            this.$api.tansfer.getStudentTransfer(
                Object.assign({}, {studentId: this.stuDetailMsg.studentId}, this.transferOptions)
            ).then(data => {
                this.transferLoading = false;

                if (data.data) {
                    this.transferDesserts = data.data;
                    this.transferTotalDesserts = data.total;
                } else {
                    this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                }

            })
        },
        initStudentAttendance() {
            this.studentLoading = true
            this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
            this.$api.attendance.getStudentAttendance(
                Object.assign({}, {studentId: this.stuDetailMsg.studentId}, this.studentOptions)
            ).then(data => {
                this.studentLoading = false;
                if (data.data) {
                    this.studentDesserts = data.data;
                    this.studentTotalDesserts = data.total;
                } else {
                    this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                }

            })
        },
        initTeacherAppraise() {
            this.teacherLoading = true
            this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
            this.$api.studentRecords.getStudentRecords(
                Object.assign({}, {stuId: this.stuDetailMsg.studentId, recordType: 0}, this.teacherOptions)
            ).then(data => {
                this.teacherLoading = false;
                if (data.data) {
                    this.teacherDesserts = data.data;
                    this.teacherTotalDesserts = data.total;
                } else {
                    this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                }

            })
        },
        initOutApprise(){
            this.outAppriseLoading = true
            this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
            this.$api.studentRecords.getStudentRecords(
                Object.assign({}, {stuId: this.stuDetailMsg.studentId, recordType: 2}, this.outAppriseOptions)
            ).then(data => {
                this.outAppriseLoading = false;
                if (data.data) {
                    this.outApprise = data.data;
                    this.outAppriseTotalDesserts = data.total;
                } else {
                    this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                }

            })
        },
        initRecordAppraise() {
            this.recordLoading = true
            this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
            this.$api.studentRecords.getStudentRecords(
                Object.assign({}, {stuId: this.stuDetailMsg.studentId, recordType: 1}, this.recordOptions)
            ).then(data => {
                this.recordLoading = false;
                if (data.data) {
                    this.recordDesserts = data.data;
                    this.recordTotalDesserts = data.total;
                } else {
                    this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                }

            })
        },
        updateStudentMsg() {
            if (this.showDetail) {
                this.$api.student.getStudentDetail({id: this.stuDetailMsg.studentId}).then(data => {
                    if (data.data) {
                        this.studentDetail = data.data
                        this.studentDetail.pic='http://localhost:8080/'+ this.studentDetail.pic
                        this.studentDetail.gender == 0 ? this.studentDetail.gender = '男' : this.studentDetail.gender == 1 ? this.studentDetail.gender = '女' : ''
                    }
                })
            }
        },
        initEcharts() {
            this.searchData.examType = []
            if (this.switch1) {
                //面试
                this.searchData.examType.push("0")
            }
            if (this.switch2) {
                //笔试
                this.searchData.examType.push("1")
            }

            this.options.xAxis[0].data = []
            this.options.series[0].data = []

            if (this.showDetail) {
                this.searchData.stuId = this.stuDetailMsg.studentId
                this.$api.achievement.studentLine(this.searchData).then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.options.xAxis[0].data.push(obj.examName)
                            this.options.series[0].data.push(obj.score)
                        })
                    }
                    setTimeout(this.$refs.etchartsRef.setOption(), 100)
                })
            }
        },
        cancelBtn() {
            this.$emit('changeShowDetail', false)
        },
        changeOptions() {
            this.initStudentAttendance()
        },
        teaChangeOptions() {
            this.initTeacherAppraise()
        },
        recordChangeOptions() {
            this.initRecordAppraise()
        },
        outAppriseChangeOptions(){
            this.initOutApprise()
        },
        transferChangeOptions() {
            this.initStudentTransfer()
        },
        initAllTab() {
            this.changeOptions()
            this.teaChangeOptions()
            this.recordChangeOptions()
            this.transferChangeOptions()
        },
    },
    components: {
        echarts
    }
}
</script>
<style scoped>
ul.message-list-menu li {
    padding: 5px 0px;
    font-size: 14px;
}

ul.message-list-menu li {
    padding: 5px 0px;
    font-size: 14px;
    border-bottom: 1px solid #303030;
}

ul.message-list-menu li:last-child {
    padding-bottom: 0px;
    border-bottom: 0px solid #ddd;
}

ul.message-list-menu li .message-time {
    text-align: right;
}

ul.message-list-menu li .message-info {
    width: 62%;;
    display: inline-block;
}

ul.message-list-menu li .message-serial {
    width: 25px;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
    background: #303030;
    color: #fff;
    border-radius: 4px;
    padding: 2px 0px;
}

ul.message-list-menu li .message-serial.message-cl-one {
    background: #03a9f0;
}

ul.message-list-menu li .message-serial.message-cl-two {
    background: #303030;
}

ul.message-list-menu li .message-serial.message-cl-three {
    background: #1ab394;
}

ul.message-list-menu li .message-serial.message-cl-four {
    background: #ccc;
    color: #303030;
}

ul.message-list-menu li .message-serial.message-cl-five {
    background: #1c84c6;
}
</style>
